module.exports = __webpack_public_path__ + "904672abf4bde6245f6fe2aceca6d3cb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-28.png
// module id = 2327
// module chunks = 0